import React from "react";

import "./random_products.css";
const RandomProducts = (props) => {
  return (
    <>
      <div className="random_block  ">
        <div className="random_block-content">
          <span>{props.subtitle}</span>
          <h3>{props.title}</h3>
          <p>{props.description}</p>
        </div>
        <div className="random_block_img   ">
          <img
            src={props.img}
            alt="random_products"
            className="img-fluid rounded-4"
            style={{ height: "400px" }}
          ></img>
        </div>
      </div>
    </>
  );
};

export default RandomProducts;
